import React from 'react';
import DonutChart from './DonutChart';

const StatusCard = ({ 
  title, 
  className = '', 
  donutChart, 
  stats = [],
  onSettingsClick 
}) => {
  return (
    <div className={`w-100 sh_statusIndicatorbox ${className} p-2`}>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="p1-strong mb-2">{title}</h1>
        <div>
          <a className="btn sh_btniconnew" onClick={onSettingsClick} style={{ cursor: 'pointer' }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.4155 6.58674C10.1962 7.36741 10.1962 8.63474 9.4155 9.41674C8.63483 10.1974 7.3675 10.1974 6.5855 9.41674C5.80483 8.63608 5.80483 7.36874 6.5855 6.58674C7.3675 5.80474 8.63417 5.80474 9.4155 6.58674" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M2 7.99992C2 7.56059 2.10133 7.12592 2.29733 6.72525V6.72525C3.30733 4.66059 5.53933 3.33325 8 3.33325C10.4607 3.33325 12.6927 4.66059 13.7027 6.72525V6.72525C13.8987 7.12592 14 7.56059 14 7.99992C14 8.43925 13.8987 8.87392 13.7027 9.27458V9.27458C12.6927 11.3393 10.4607 12.6666 8 12.6666C5.53933 12.6666 3.30733 11.3393 2.29733 9.27458V9.27458C2.10133 8.87392 2 8.43925 2 7.99992Z" stroke="#1D1917" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
      <div className="d-flex align-items-center">
        {donutChart && <DonutChart {...donutChart} onIconClick={onSettingsClick} />}
        <div className="d-flex flex-column w-100">
          {stats.map((stat, index) => (
            <div key={index} className="d-flex justify-content-between">
              <p className="p3-light text-dark mb-1">
                <span className="mr-1">
                  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="12" height="12" rx="6" fill={stat.color}></rect>
                  </svg>
                </span>
                {stat.label}
              </p>
              <p className="p3-light text-dark mb-1">{stat.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusCard;

